import React, { useState, useRef, KeyboardEvent, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import {
  Link,
  useNavigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import "./LandingPage.css";

/* ------------------------------------------------------------------
   Ivy League list for inline suggestions
------------------------------------------------------------------ */
const IVY_LEAGUE_SCHOOLS = [
  "ASU",
  "Alabama",
  "Arizona State University",
  "Arkansas",
  "BU",
  "BYU",
  "Bentley",
  "Bentley University",
  "Berkeley",
  "Boise State",
  "Boise State University",
  "Boston University",
  "Bridgewater State",
  "Bridgewater State University",
  "Brigham Young University",
  "Brown",
  "Brown University",
  "CMU",
  "CSU",
  "CU Boulder",
  "California Institute of Technology",
  "California Institute of Technology University",
  "Caltech",
  "Carnegie Mellon University",
  "Case Western",
  "Case Western Reserve University",
  "Central Connecticut",
  "Central Connecticut State University",
  "Colorado State University",
  "Columbia",
  "Columbia University",
  "Cornell",
  "Cornell University",
  "Dartmouth",
  "Dartmouth College",
  "Dartmouth College University",
  "Denver",
  "Duke",
  "Duke University",
  "Eastern Connecticut",
  "Eastern Connecticut State University",
  "Emory",
  "Emory University",
  "Fairfield",
  "Fairfield University",
  "Framingham State",
  "Framingham State University",
  "Georgia Institute of Technology",
  "Georgia Institute of Technology University",
  "Georgia Tech",
  "Harvard",
  "Harvard University",
  "IU Bloomington",
  "Idaho",
  "Indiana",
  "Indiana University Bloomington",
  "Indiana University Bloomington University",
  "Iowa",
  "KU",
  "MIT",
  "MSU",
  "Massachusetts Institute of Technology",
  "Massachusetts Institute of Technology University",
  "Miami",
  "Michigan",
  "Michigan State University",
  "Mizzou",
  "Montana State",
  "Montana State University",
  "Montclair State",
  "Montclair State University",
  "NDSU",
  "NMSU",
  "NYU",
  "Nebraska",
  "New Mexico State University",
  "New York University",
  "North Dakota State University",
  "Northeastern",
  "Northeastern University",
  "Northwestern",
  "Northwestern University",
  "Notre Dame",
  "OSU",
  "OU",
  "Ohio State",
  "Ohio State University",
  "Ole Miss",
  "Oregon",
  "Oregon State University",
  "PSU",
  "Penn",
  "Penn State",
  "Pennsylvania State University",
  "Pitt",
  "Portland State University",
  "Princeton",
  "Princeton University",
  "Purdue",
  "Purdue University",
  "RIC",
  "Rhode Island",
  "Rhode Island College",
  "Rhode Island College College",
  "Rice",
  "Rice University",
  "Rochester",
  "Rowan",
  "Rowan University",
  "Rutgers",
  "Rutgers University",
  "SDSU",
  "Sacred Heart",
  "Sacred Heart University",
  "Salem State",
  "Salem State University",
  "San Diego State University",
  "South Dakota State University",
  "Southern Connecticut",
  "Southern Connecticut State University",
  "Stanford",
  "Stanford University",
  "Suffolk",
  "Suffolk University",
  "Texas",
  "Texas A&M",
  "Texas A&M University",
  "Tufts",
  "Tufts University",
  "UAA",
  "UAF",
  "UArizona",
  "UC Berkeley",
  "UCLA",
  "UChicago",
  "UConn",
  "UD",
  "UF",
  "UGA",
  "UH Manoa",
  "UIUC",
  "UK",
  "UMD",
  "UMN",
  "UMT",
  "UMaine",
  "UMass",
  "UMass Amherst",
  "UMich",
  "UNC",
  "UNC Chapel Hill",
  "UND",
  "UNH",
  "UNLV",
  "UNM",
  "UNR",
  "UPenn",
  "URI",
  "USC",
  "USD",
  "UT Austin",
  "UVA",
  "UVM",
  "UW",
  "University of Alabama",
  "University of Alabama University",
  "University of Alaska Anchorage",
  "University of Alaska Fairbanks",
  "University of Arizona",
  "University of Arizona University",
  "University of Arkansas",
  "University of Arkansas University",
  "University of California at Berkeley",
  "University of California, Berkeley",
  "University of California, Los Angeles",
  "University of California, Los Angeles University",
  "University of Chicago",
  "University of Chicago University",
  "University of Colorado Boulder",
  "University of Colorado Boulder University",
  "University of Connecticut",
  "University of Delaware",
  "University of Denver",
  "University of Florida",
  "University of Florida University",
  "University of Georgia",
  "University of Georgia University",
  "University of Hawaii at Manoa",
  "University of Idaho",
  "University of Illinois Urbana-Champaign",
  "University of Illinois Urbana-Champaign University",
  "University of Iowa",
  "University of Iowa University",
  "University of Kansas",
  "University of Kansas University",
  "University of Kentucky",
  "University of Kentucky University",
  "University of Maine",
  "University of Maryland, College Park",
  "University of Maryland, College Park University",
  "University of Massachusetts Amherst",
  "University of Miami",
  "University of Miami University",
  "University of Michigan",
  "University of Michigan University",
  "University of Minnesota",
  "University of Minnesota University",
  "University of Mississippi",
  "University of Mississippi University",
  "University of Missouri",
  "University of Missouri University",
  "University of Montana",
  "University of Nebraska",
  "University of Nebraska University",
  "University of Nevada, Las Vegas",
  "University of Nevada, Reno",
  "University of New Hampshire",
  "University of New Mexico",
  "University of North Carolina at Chapel Hill",
  "University of North Carolina at Chapel Hill University",
  "University of North Dakota",
  "University of Notre Dame",
  "University of Notre Dame University",
  "University of Oklahoma",
  "University of Oklahoma University",
  "University of Oregon",
  "University of Pennsylvania",
  "University of Pennsylvania University",
  "University of Pittsburgh",
  "University of Pittsburgh University",
  "University of Rhode Island",
  "University of Rochester",
  "University of Rochester University",
  "University of South Dakota",
  "University of Southern California",
  "University of Southern California University",
  "University of Texas at Austin",
  "University of Texas at Austin University",
  "University of Utah",
  "University of Vermont",
  "University of Virginia",
  "University of Virginia University",
  "University of Washington",
  "University of Washington University",
  "University of Wisconsin-Madison",
  "University of Wisconsin-Madison University",
  "University of Wyoming",
  "Utah",
  "Utah State",
  "Utah State University",
  "Vanderbilt",
  "Vanderbilt University",
  "Virginia",
  "WSU",
  "Wake Forest",
  "Wake Forest University",
  "Washington State University",
  "Western Connecticut",
  "Western Connecticut State University",
  "Wisconsin",
  "Worcester State",
  "Worcester State University",
  "Wyoming",
  "Yale",
  "Yale University",
];

/* ------------------------------------------------------------------
   Styled Components
------------------------------------------------------------------ */
const ChatSection = styled.div<{ isDragging?: boolean }>`
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  border-top: 1px solid #e0e0e0;
  background-color: ${({ isDragging }) => (isDragging ? "#e0f7ff" : "#f7f9fc")};
  border: ${({ isDragging }) => (isDragging ? "2px dashed #007bff" : "none")};
  transition: background-color 0.2s, border 0.2s;
  padding-bottom: 80px;
`;

const ChatBottom = styled.div<{ mobileOpen?: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #1f1f1f;
  padding: 20px 20px 30px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.6);

  @media (max-width: 600px) {
    position: static;
    display: ${({ mobileOpen }) => (mobileOpen ? "flex" : "none")};
    box-shadow: none;
    overscroll-behavior: none;
  }
`;

const BackLink = styled.button`
  display: none;
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-decoration: underline;
  margin-bottom: 10px;
  cursor: pointer;
  align-self: flex-start;

  @media (max-width: 600px) {
    display: block;
  }
`;

const MobileFooter = styled.div`
  display: none;
  @media (max-width: 600px) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(180deg, #2ecc71, #27ae60);
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.6);
    z-index: 1000;
    cursor: pointer;
    align-items: center;
    justify-content: flex-start;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.05em;
    color: #fff;

    span {
      flex: 1;
      text-align: left;
    }

    button {
      margin-left: auto;
    }
  }
`;

const arrowDataUri = `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><line x1='12' y1='19' x2='12' y2='5' stroke='currentColor' stroke-width='3' stroke-linecap='round'/><polyline points='5 12 12 5 19 12' fill='none' stroke='currentColor' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/></svg>`;

const SendButton = styled.button<{ empty?: boolean }>`
  background: ${({ empty }) => (empty ? "#444" : "#fff")} url("${arrowDataUri}")
    no-repeat center/24px;
  @media (max-width: 600px) {
    background-size: 24px;
  }
  color: #1f1f1f;
  border: none;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  font-size: 16px;
  font-weight: 600;
  transition: box-shadow 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 12px;
  right: 10px;
  z-index: 4;
  &:hover {
    box-shadow: ${({ empty }) => (empty ? "none" : "0 0 8px 4px #ffffff66")};
  }
`;

const MobileFooterButton = styled.button`
  background: #fff url("${arrowDataUri}") no-repeat center/24px;
  @media (max-width: 600px) {
    background-size: 24px;
  }
  border: none;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChatInputWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

const TargetHeader = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.05em;
  cursor: pointer;
  margin-bottom: 10px;
  padding-left: 2px;
  align-self: flex-start;

  @media (max-width: 600px) {
    width: 100%;
    text-align: left;
  }
`;

const PopularTargetsContainer = styled.div`
  max-width: 600px;
  margin-bottom: 15px;
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 5px;
  overflow: hidden;
`;

const PopularTargetButton = styled.button`
  background: none;
  border: 1px solid #2ecc71;
  border-radius: 4px;
  color: #2ecc71;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  &:hover {
    background-color: #2ecc71;
    color: #1f1f1f;
  }
`;

const HideOnMobileButton = styled(PopularTargetButton)`
  @media (max-width: 600px) {
    display: none;
  }
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

/* ----- textarea & inline suggestion overlay ----- */
const TextArea = styled.textarea`
  position: relative;
  z-index: 3;
  max-width: 600px;
  background: none;
  color: transparent; /* hide typed text */
  caret-color: #fff; /* keep caret visible */
  width: 100%;
  padding: 10px;
  font-size: 20px;
  font-family: inherit;
  border-radius: 8px;
  border: 1px solid #ccc;
  resize: none;
  overflow-y: hidden;
  min-height: 90px;
  max-height: 240px;
  box-sizing: border-box;
  transition: border-color 0.2s;
  border-color: #777;
  &:focus {
    outline: none;
    border-color: #2ecc71;
    box-shadow: 0 0 10px 4px #2ecc7166;
  }
`;

const GhostOverlay = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
  font-family: inherit;
  line-height: 1.4;
  color: #666;
  pointer-events: none;
  user-select: none;
  white-space: pre-wrap;
  z-index: 2;

  span:first-child {
    color: #fff; /* show typed portion in white */
  }
`;

const slideUp = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0);   opacity: 1; }
`;

const AnimatedPlaceholder = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
  color: #888;
  pointer-events: none;
  z-index: 1;
  animation: ${slideUp} 0.4s ease-in-out forwards;
`;

const slideUpExit = keyframes`
  from { transform: translateY(0);   opacity: 1; }
  to   { transform: translateY(-20px); opacity: 0; }
`;

const AnimatedPlaceholderExit = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
  color: #888;
  pointer-events: none;
  z-index: 1;
  animation: ${slideUpExit} 0.4s ease-in-out forwards;
`;

/* ----- extra styled components for landing content / press bar ----- */
const Subtitle1 = styled.h2`
  @media (max-width: 600px) {
    display: none;
  }
`;

const PressBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin: 15px 0 20px 0;
  flex-wrap: wrap;
  a {
    text-decoration: none;
  }

  @media (max-width: 600px) {
    display: none;
  }
`;

const PressItem = styled.div`
  height: 18px;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #ccc;
  gap: 6px;
  background: #1f1f1f;
  border: 1px solid #444;
  padding: 4px 10px;
  border-radius: 6px;
`;

const PressLogo = styled.img`
  height: 16px;
  filter: grayscale(100%);
  object-fit: contain;
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2999;
`;

const SuccessPopup = styled.div`
  position: fixed;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #2ecc71;
  color: #1f1f1f;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  z-index: 3000;
  width: 80%;
  max-width: 500px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
`;

const ShareBadge = styled.a`
  display: inline-block;
  padding: 6px 15px;
  border-radius: 1.2rem;
  font-size: 0.9rem;
  font-weight: bold;
  color: #1f1f1f;
  background-color: #ffffff;
  margin-top: 15px;
  text-decoration: none;
  &:hover {
    background-color: #aaa;
  }
`;

/* ---------- RESTORED STYLING FOR SCHOOL BOXES ---------- */
const CompactBoxImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  padding: 8px;
`;

const CompactBoxContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SchoolLabel = styled.div`
  margin: 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: white;
`;

const DirectReports2 = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 8px;
    margin: 12px auto;
    padding-bottom: 80px;

    > a {
      display: flex;
      align-items: center;
      background-color: #1f1f1f;
      padding: 10px 16px;
      border-radius: 8px;
      width: 100%;
      text-decoration: none;
    }

    ${CompactBoxContent} {
      flex-direction: row;
    }

    ${CompactBoxImg} {
      width: 40px;
      height: auto;
      margin-right: 8px;
    }

    ${SchoolLabel} {
      font-size: 16px;
      text-align: left;
      margin: 0;
    }
  }
`;

/* ------------------------------------------------------------------
   AltLanding Component
------------------------------------------------------------------ */
const AltLanding: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  /* ----- initial state ----- */
  const openFromState = (location.state as any)?.openChat === true;
  const openFromParam = searchParams.get("chat") === "true";
  const shouldOpenChat = openFromState || openFromParam;
  const [mobileOpen, setMobileOpen] = useState(
    () => shouldOpenChat && window.innerWidth < 600
  );

  const institutionParam = searchParams.get("institution");
  const showFOIASuccess = searchParams.get("success") === "true";

  const navigate = useNavigate();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const ignoreBlurRef = useRef(false);

  const [inputValue, setInputValue] = useState("");
  const [isStreaming, setIsStreaming] = useState(false);

  const placeholders = [
    "Harvard University...",
    "Boston Public Schools...",
    "Yale University...",
    "Florida State University...",
    "Stanford University...",
    "Columbia University...",
    "University of Michigan...",
    "Texas A&M University...",
    "Los Angeles Unified School District...",
    "Brown University...",
  ];
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [prevPlaceholder, setPrevPlaceholder] = useState<string | null>(null);

  /* ----- inline suggestion logic ----- */
  const matchSchool = IVY_LEAGUE_SCHOOLS.find(
    (s) =>
      inputValue &&
      s.toLowerCase().startsWith(inputValue.toLowerCase()) &&
      s.toLowerCase() !== inputValue.toLowerCase()
  );
  const remainder = matchSchool ? matchSchool.slice(inputValue.length) : "";

  /* ----- rotating placeholder ----- */
  useEffect(() => {
    const id = setInterval(() => {
      if (!inputValue.trim()) {
        setPrevPlaceholder(placeholders[placeholderIndex]);
        setPlaceholderIndex((i) => (i + 1) % placeholders.length);
      }
    }, 800);
    return () => clearInterval(id);
  }, [inputValue, placeholderIndex]);

  useEffect(() => {
    if (prevPlaceholder) {
      const t = setTimeout(() => setPrevPlaceholder(null), 400);
      return () => clearTimeout(t);
    }
  }, [prevPlaceholder]);

  useEffect(() => {
    if (mobileOpen) textareaRef.current?.focus();
  }, [mobileOpen]);

  /* ----- key handler ----- */
  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (isStreaming) return;
    if (e.key === "Tab" && matchSchool) {
      e.preventDefault();
      setInputValue(matchSchool);
      return;
    }
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (inputValue.trim())
        navigate("/chat", { state: { query: inputValue.trim() } });
    }
  };

  /* ------------------------------------------------------------------
     Render
  ------------------------------------------------------------------ */
  return (
    <div>
      {/* ----------------- Institution success popup ----------------- */}
      {institutionParam && (
        <Overlay onClick={() => navigate("/")}>
          <SuccessPopup onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => navigate("/")}>×</CloseButton>
            <h2>
              Congrats on telling {institutionParam} to cease and desist DEI!
            </h2>
            <ShareBadge
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                `I just told ${institutionParam} to cease and desist DEI with Trialhouse!`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Share on X
            </ShareBadge>
          </SuccessPopup>
        </Overlay>
      )}

      {/* ----------------- FOIA success popup ----------------- */}
      {showFOIASuccess && (
        <Overlay onClick={() => navigate("/")}>
          <SuccessPopup onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => navigate("/")}>×</CloseButton>
            <h2>🎉 Congrats!</h2>
            <p>Your FOIA request was submitted.</p>
            <ShareBadge
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                "I just filed a FOIA request using Trialhouse. Join the fight for transparency at https://trialhouse.com"
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Share on X
            </ShareBadge>
          </SuccessPopup>
        </Overlay>
      )}

      {/* ----------------- Landing content (desktop) ----------------- */}
      {!mobileOpen && (
        <>
          <div className="landing-page">
            <Helmet key="title">
              <title>Trialhouse</title>
              <meta
                name="description"
                content="We emailed every administrator. Now they have to justify their jobs."
              />
            </Helmet>

            <Subtitle1 className="center-subtitle1">
              We caught Elon Musk's attention by mass-emailing administrators at
              Brown. Now we're expanding to Columbia, Penn, and Cornell.
            </Subtitle1>

            <PressBar>
              <a
                href="https://x.com/elonmusk/status/1907121750082465968"
                target="_blank"
                rel="noopener noreferrer"
              >
                <PressItem>
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/5/5a/X_icon_2.svg"
                    alt="X logo"
                    height="16"
                  />
                  @ElonMusk
                </PressItem>
              </a>
              <a
                href="https://www.foxnews.com/media/ivy-league-student-accused-causing-emotional-harm-non-faculty-staff-sending-doge-like-email"
                target="_blank"
                rel="noopener noreferrer"
              >
                <PressLogo
                  src="https://upload.wikimedia.org/wikipedia/commons/d/de/Fox_News_Media_Logo.svg"
                  alt="Fox News"
                />
              </a>
              <a
                href="https://www.newsweek.com/alex-shieh-college-student-targets-бloat-brown-university-2051470"
                target="_blank"
                rel="noopener noreferrer"
              >
                <PressLogo
                  src="https://upload.wikimedia.org/wikipedia/commons/d/db/Newsweek_Logo.svg"
                  alt="Newsweek"
                />
              </a>
              <a
                href="https://nypost.com/2025/04/04/media/brown-university-student-angers-non-faculty-employees-by-asking-what-do-you-do-all-day-faces-пunishment/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <PressLogo
                  src="https://upload.wikimedia.org/wikipedia/commons/2/26/New_York_Post.svg"
                  alt="New York Post"
                />
              </a>
            </PressBar>

            <h1 className="center-title">
              We emailed Ivy League administrators. Now they have to justify
              their jobs.
            </h1>
            <h2 className="center-subtitle">
              Find out what the bureaucracy does all day — besides losing
              billions in federal funds.
            </h2>
          </div>

          <DirectReports2 className="direct-reports2">
            {[
              {
                to: "/brown",
                src: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Brown_Bears_Athletics_logo.svg",
                label: "Brown",
              },
              {
                to: "/columbia",
                src: "https://upload.wikimedia.org/wikipedia/en/5/5f/Columbia_Lions_logo.svg",
                label: "Columbia",
              },
              {
                to: "/penn",
                src: "https://upload.wikimedia.org/wikipedia/commons/c/c7/Penn_Quakers_logo.svg",
                label: "Penn",
              },
              {
                to: "/cornell",
                src: "https://upload.wikimedia.org/wikipedia/en/9/9b/Cornell_Big_Red_logo.svg",
                label: "Cornell",
              },
            ].map(({ to, src, label }) => (
              <Link
                key={label}
                to={to}
                className="compact-box1"
                style={{ "--accent-color": "#2ecc71" } as React.CSSProperties}
              >
                <CompactBoxContent>
                  <CompactBoxImg src={src} alt={label} />
                  <SchoolLabel>{label}</SchoolLabel>
                </CompactBoxContent>
              </Link>
            ))}
          </DirectReports2>
        </>
      )}

      {/* ----------------- Mobile footer button ----------------- */}
      {!mobileOpen && (
        <MobileFooter onClick={() => setMobileOpen(true)}>
          <span>TELL ANY SCHOOL IN AMERICA TO STOP DEI</span>
          <MobileFooterButton />
        </MobileFooter>
      )}

      {/* ----------------- Chat bottom (desktop & mobile overlay) ----------------- */}
      <ChatBottom mobileOpen={mobileOpen}>
        <BackLink onClick={() => setMobileOpen(false)}>← Back</BackLink>
        <ChatInputWrapper>
          <TargetHeader>TELL ANY SCHOOL IN AMERICA TO STOP DEI</TargetHeader>

          <PopularTargetsContainer>
            <span
              style={{
                marginRight: "5px",
                color: "#aaa",
                fontSize: "14px",
                alignSelf: "center",
              }}
            >
              Popular targets:
            </span>
            {[
              { label: "Harvard", hideOnMobile: false },
              { label: "Columbia", hideOnMobile: true },
              { label: "University of Michigan", hideOnMobile: true },
              { label: "UCLA", hideOnMobile: false },
            ].map(({ label, hideOnMobile }) => {
              const Button = hideOnMobile
                ? HideOnMobileButton
                : PopularTargetButton;
              return (
                <Button
                  key={label}
                  onMouseDown={() => {
                    ignoreBlurRef.current = true;
                  }}
                  onClick={() => navigate("/chat", { state: { query: label } })}
                >
                  {label}
                </Button>
              );
            })}
          </PopularTargetsContainer>

          <InputContainer>
            {/* inline suggestion overlay */}
            {(inputValue || remainder) && (
              <GhostOverlay>
                <span>{inputValue}</span>
                <span>{remainder}</span>
              </GhostOverlay>
            )}

            <TextArea
              ref={textareaRef}
              autoFocus
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              onBlur={() => {
                if (ignoreBlurRef.current) {
                  ignoreBlurRef.current = false;
                  return;
                }
                if (!inputValue.trim()) setMobileOpen(false);
              }}
              placeholder=""
            />

            {!inputValue && prevPlaceholder && (
              <AnimatedPlaceholderExit key={`exit-${placeholderIndex}`}>
                {prevPlaceholder}
              </AnimatedPlaceholderExit>
            )}
            {!inputValue && (
              <AnimatedPlaceholder key={`enter-${placeholderIndex}`}>
                {placeholders[placeholderIndex]}
              </AnimatedPlaceholder>
            )}

            {isStreaming ? (
              <SendButton empty={false} onClick={() => setIsStreaming(false)}>
                Stop
              </SendButton>
            ) : (
              <SendButton
                empty={!inputValue.trim()}
                onClick={() =>
                  inputValue.trim() &&
                  navigate("/chat", { state: { query: inputValue.trim() } })
                }
              />
            )}
          </InputContainer>
        </ChatInputWrapper>
      </ChatBottom>
    </div>
  );
};

export default AltLanding;
